const proxyAddWidgetToParentContext = (event) => {
  const { frameElement } = event.target.ownerDocument.defaultView;

  const addWidgetEvent = new CustomEvent('ws:addWidget', {
    bubbles: true,
    detail: {
      originalEvent: event,
    },
  });

  frameElement.dispatchEvent(addWidgetEvent);
};

export default proxyAddWidgetToParentContext;
